module.exports = __webpack_public_path__ + "img/firefox.5af1a287.svg";